import React from 'react'

const TournamentStandings = ({ standings }) => (
  <table className="tournament-standings">
    <thead>
      <tr>
        <th>Time</th>
        <th>P</th>
        <th>V</th>
        <th>E</th>
        <th>D</th>
        <th>GP</th>
        <th>GC</th>
        <th>SG</th>
        <th>Pts</th>
      </tr>
    </thead>
    <tbody>
      {standings.map((row, index) => (
        <tr key={row.team} className={index === 0 ? 'leader' : ''}>
          <td>{row.team}</td>
          <td>{row.played}</td>
          <td>{row.wins}</td>
          <td>{row.draws}</td>
          <td>{row.losses}</td>
          <td>{row.goalsFor}</td>
          <td>{row.goalsAgainst}</td>
          <td>{row.goalDiff}</td>
          <td>
            <strong>{row.points}</strong>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
)

export default TournamentStandings
